import { Layout } from 'antd';
import { SiderProps } from 'antd/lib/layout/Sider';
import React from 'react';

const SiderBase = Layout.Sider;

export interface ISiderProps extends SiderProps {}

const Sider: React.FC<ISiderProps> = ({ children, ...props }) => {
  return <SiderBase {...props}>{children}</SiderBase>;
};

export default Sider;
